import { ActionAPI, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BrokerService, HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { Inject } from '@odinjs/odin';

import { TasksUtils } from '../../utils/tasks-utils';
import TaskItem from '../../interfaces/task-item';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { FragmentNames } from '../../codegen';
import { ProfileUpdateAliases } from '../../codegen';
import { BS_TASK_LIST_BLOCK_PROFILE_EDITING } from '../../constants/application-constants';
import ProfileBaseController from '../profile-base-controller';

@Controller({ component: ProfileUpdateAliases.PROFILE_UPDATE_LAYOUT, fragment: FragmentNames.PROFILE_UPDATE })
export default class ProfileUpdateController extends ProfileBaseController {

  @Inject(ProfileUpdateAliases.TOAST_NOTIFICATION)
    toastNotificationBlockMessageApi!: ToastNotificationAPI;

  disableCheckAction = true;

  @OnMount(ProfileUpdateAliases.PROFILE_UPDATE_CHECK_ACTION)
  onLayoutMount(event: MountEvent): void {
    super.setContextVariablesForTaskModule();
    const checkActionAPI = event.target as ActionAPI;
    const profileUpdateTask = this.context.get<TaskItem>(this.ContextKeys.PROFILE_UPDATE_TASK);

    TasksUtils.setInitialActionStatus({
      checkActionAPI,
      onBlocked: () => {
        this.disableCheckAction = true;
        this.toastNotificationBlockMessageApi.setVisible(true);
        BrokerService.publishToTopic(BS_TASK_LIST_BLOCK_PROFILE_EDITING, true);
      },
      onCompleted: () => {
        checkActionAPI.setText(MessageService.translate('patient.checked'));
        checkActionAPI.setButtonTheme(ButtonTheme.ACCENT);
        this.disableCheckAction = true;
      },
      onPending: () => {
        this.disableCheckAction = false;
        this.context.set({ nrSequencia: profileUpdateTask.nrSequencia });
      },
      taskItem: profileUpdateTask,
    });
  }

  @OnClick(ProfileUpdateAliases.PROFILE_UPDATE_CHECK_ACTION)
  onClickCheckAction(event: ClickEvent): void {
    if (this.disableCheckAction) return;

    const checkAction = event.target as ActionAPI;
    const identifier = this.context.get('identifier') as string;
    const nrSequencia = this.context.get('nrSequencia');

    HttpService.put(APPLICATION_ENDPOINTS.UPDATE_TASK_STATUS, { nrSequencia }).then(() => {
      TasksUtils.setActionChecked(checkAction, identifier);
      this.disableCheckAction = true;
      BrokerService.publishToTopic(BS_TASK_LIST_BLOCK_PROFILE_EDITING, true);
    });
  }
}
